import React, { useCallback } from "react";
import { FieldProps } from "formik";
import { OptionsType } from "react-select/src/types";

import { Select as CustomSelect, IOption } from "../../components/Select";

interface IProps extends FieldProps {
  options: OptionsType<IOption>;
}

export const Select: React.FC<IProps> = (
  {
    field: { name, value },
    form: { setFieldValue, isSubmitting },
    options,
  }
) => {
  const handleOnChange = useCallback((v: string) => {
    setFieldValue(name, v);
  }, [name, setFieldValue]);

  return (
    <CustomSelect
      value={value}
      options={options}
      isDisabled={isSubmitting}
      handleOnChange={handleOnChange}
    />
  );
};
